import { render } from "./ListeInscription.vue?vue&type=template&id=351aa31e&ts=true"
import script from "./ListeInscription.vue?vue&type=script&lang=ts"
export * from "./ListeInscription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__